import { render, staticRenderFns } from "./CommodityProviders.vue?vue&type=template&id=28cfc1ac&"
import script from "./CommodityProviders.vue?vue&type=script&lang=js&"
export * from "./CommodityProviders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports